<!-- Megjelenítés -->
<div class="container">
    <div class="m-3">
        <div class="d-xl-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <h3 class="display-6 d-block m-0">{{ 'Task.AutDistribution' | translate:locale.language }}</h3>
            </div>
            <div class="d-md-flex align-items-center">
                <div *ngIf="option == 1">
                    <button type="button" class="btn btn-success" (click)="clickNew()">
                        <i class="bi bi-plus"></i> {{ 'Task.NewTask' | translate:locale.language }}
                    </button>
                </div>

            </div>
        </div>
        <hr>
        <!-- Opciók -->
        <div class="d-lg-flex justify-content-between mb-3">
            <ul class="nav nav-pills rounded-selector mb-3 mb-lg-0">
                <li class="nav-item">
                    <a [ngClass]="selectedOption.value == 0 ? 'nav-link active' : 'nav-link '"
                        (click)="onOptionChanged(30,0)" aria-current="page"
                        href="javascript:void(0)"><span>Default</span></a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="selectedOption.value == 1 ? 'nav-link active position-relative' : 'nav-link position-relative'"
                        (click)="onOptionChanged(90,1)" href="javascript:void(0)">
                        <span>{{ 'Task.Individual' | translate:locale.language }}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a [ngClass]="selectedOption.value == 2 ? 'nav-link active position-relative' : 'nav-link position-relative'"
                        (click)="onOptionChanged(180,2)" href="javascript:void(0)">
                        <span>{{ 'Core.Noo' | translate:locale.language }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <table *ngIf="taskSablonList && taskSablonList.length" class="table text-center ">
            <thead>
                <tr>
                    <th *ngIf="option == 1" style="min-width:100px"></th>
                    <th>{{ 'Task.Task' | translate:locale.language }}</th>
                    <th>{{ 'Task.StartShift' | translate:locale.language }}</th>
                    <th>{{ 'Task.Frequency' | translate:locale.language }}</th>
                </tr>
            </thead>
            <tbody class="bg-white">
                <tr *ngFor="let item of taskSablonList; index as i">
                    <td *ngIf="option == 1" class="text-start">
                        <a (click)="clickDelete(i)" class="h4 text-danger me-4 me-lg-3 pointer"><i
                                class="bi bi-trash"></i></a>
                        <a (click)="clickEdit(i)" class="h4 text-primary pointer"><i class="bi bi-pencil"></i></a>
                    </td>
                    <td>{{ item.gameId | codeTranslate:gamesSource }}</td>
                    <td>{{ item.dayOffset }}</td>
                    <td>{{ item.frequencyId | codeTranslate:regularitySource }}</td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error | translate:locale.language}}</div>
    </div>
</div>

<ng-template #editFormtmpl>
    <div *ngIf="editItem">
        <div class="modal-header">
            <h5 *ngIf="addNew" class="modal-title">{{ 'Task.NewTask' | translate:locale.language }}</h5>
            <h5 *ngIf="!addNew" class="modal-title">{{ 'Task.Task' | translate:locale.language }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closeModal()" aria-label="Close">
            </button>
        </div>
        <div class="modal-body">
            <form action="your-action" (submit)="onFormSubmit($event,selectedIndex)">
                <div class="mb-3">
                    <div class="form-label">{{ 'Task.Task' | translate:locale.language }}</div>
                    <dx-select-box [dataSource]="gamesSource" valueExpr="id" stylingMode="filled"
                        displayExpr="descriptionTranslated" [searchEnabled]="true" [(value)]="editItem.gameId">
                        <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>
                <div class="mb-3">
                    <div class="form-label">{{ 'Task.StartShift' | translate:locale.language }}</div>
                    <dx-number-box stylingMode="filled" [(value)]="editItem.dayOffset" [showSpinButtons]="true">

                        <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                            <dxi-validation-rule type="range" [max]=30 [min]=0>
                            </dxi-validation-rule>
                        </dx-validator>
                    </dx-number-box>
                </div>
                <div class="mb-3">
                    <div class="form-label">{{ 'Task.Frequency' | translate:locale.language }}</div>
                    <dx-select-box [dataSource]="regularitySource" valueExpr="id" stylingMode="filled"
                        displayExpr="descriptionTranslated" [(value)]="editItem.frequencyId">
                        <dx-validator>
                            <dxi-validation-rule type="required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-select-box>
                </div>

                <div class="modal-footer">
                    <dx-button stylingMode="contained" text="{{ 'Core.EditSave' | translate:locale.language }}"
                        type="default" useSubmitBehavior=true>
                    </dx-button>
                    <button type="button" (click)="closeModal()" class="btn btn-neutral" data-bs-dismiss="modal">
                        {{ 'Core.EditCancel' | translate:locale.language }}
                    </button>
                </div>
            </form>
            <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error | translate:locale.language}}</div>
        </div>
    </div>
</ng-template>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [position]="{ of: '#reg' }" [(visible)]="loading"
    [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false" (onShown)="onShown()">
</dx-load-panel>